(() => {
  const initialize = (scope) => {
    scope.querySelectorAll('[data-spoils-parts-care]').forEach((root) => {
      if (root.dataset.partsReady) return;
      const rail = root.querySelector('[data-parts-cards]');
      const current = root.querySelector('[data-parts-current]');
      if (!rail || !current) return;
      root.dataset.partsReady = 'true';
      const cards = Array.from(rail.children);
      let frame = 0;
      const activeIndex = () => {
        if (rail.scrollWidth > rail.clientWidth && rail.scrollLeft >= rail.scrollWidth - rail.clientWidth - 2) return cards.length - 1;
        const railLeft = rail.getBoundingClientRect().left;
        const gutter = parseFloat(getComputedStyle(rail).paddingInlineStart) || 0;
        let nearest = 0;
        cards.forEach((card, index) => {
          if (Math.abs(card.getBoundingClientRect().left - railLeft - gutter) <
              Math.abs(cards[nearest].getBoundingClientRect().left - railLeft - gutter)) nearest = index;
        });
        return nearest;
      };
      rail.addEventListener('scroll', () => {
        if (frame) return;
        frame = requestAnimationFrame(() => {
          current.textContent = String(activeIndex() + 1);
          frame = 0;
        });
      }, { passive: true });
      let drag = null;
      let suppressClick = false;
      rail.addEventListener('pointerdown', (event) => {
        suppressClick = false;
        if (event.pointerType !== 'mouse' || event.button !== 0 || rail.scrollWidth <= rail.clientWidth) return;
        drag = { id: event.pointerId, x: event.clientX, y: event.clientY, left: rail.scrollLeft, moved: false };
      });
      rail.addEventListener('pointermove', (event) => {
        if (!drag || event.pointerId !== drag.id) return;
        const distance = event.clientX - drag.x;
        if (!drag.moved && Math.hypot(distance, event.clientY - drag.y) <= 5) return;
        if (!drag.moved) {
          drag.moved = true;
          rail.setPointerCapture(event.pointerId);
          rail.classList.add('is-dragging');
        }
        event.preventDefault();
        rail.scrollLeft = drag.left - distance;
      });
      const finishDrag = (event) => {
        if (!drag || event.pointerId !== drag.id) return;
        const moved = drag.moved;
        drag = null;
        rail.classList.remove('is-dragging');
        if (rail.hasPointerCapture(event.pointerId)) rail.releasePointerCapture(event.pointerId);
        if (!moved) return;
        suppressClick = event.type === 'pointerup';
        const gutter = parseFloat(getComputedStyle(rail).paddingInlineStart) || 0;
        const index = activeIndex();
        const left = rail.scrollLeft + cards[index].getBoundingClientRect().left - rail.getBoundingClientRect().left - gutter;
        rail.scrollTo({ left, behavior: 'instant' });
      };
      rail.addEventListener('pointerup', finishDrag);
      rail.addEventListener('pointercancel', finishDrag);
      rail.addEventListener('lostpointercapture', finishDrag);
      rail.addEventListener('pointerleave', (event) => {
        if (drag && !drag.moved) drag = null;
      });
      rail.addEventListener('click', (event) => {
        if (!suppressClick) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        suppressClick = false;
      }, true);
      rail.addEventListener('keydown', (event) => {
        if (event.target !== rail || rail.scrollWidth <= rail.clientWidth) return;
        const keys = ['ArrowLeft', 'ArrowRight', 'Home', 'End'];
        if (!keys.includes(event.key)) return;
        event.preventDefault();
        const index = activeIndex();
        const next = event.key === 'Home' ? 0 : event.key === 'End' ? cards.length - 1 :
          Math.max(0, Math.min(cards.length - 1, index + (event.key === 'ArrowRight' ? 1 : -1)));
        const gutter = parseFloat(getComputedStyle(rail).paddingInlineStart) || 0;
        const left = rail.scrollLeft + cards[next].getBoundingClientRect().left - rail.getBoundingClientRect().left - gutter;
        rail.scrollTo({ left, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(document), { once: true });
  else initialize(document);
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
